import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import CompanyLogo from 'components/companyLogo';
import Ratings from 'components/ratings';
import ZpButton from 'components/zpButton';
import { withTracking } from 'hooks';
import { reviewResponse } from 'services/jobReviewService';
import { isEmptyObj } from 'utils';
import { gtmLogCompanyReviewSubmitEvent } from 'utils/analyticsGTM';
import { COMPANY_REVIEW_RATING_CATEGORIES as categories } from 'utils/constant';
import { TRACKING } from 'utils/constant';

import ReviewSubmit from '../reviewSubmit';

import classes from './index.module.css';

const propTypes = {
  companyName: PropTypes.string,
  companyLogo: PropTypes.string,
  newDesign: PropTypes.bool,
  customOnClick: PropTypes.func,
};

const defaultProps = {
  companyName: '',
  companyLogo: '',
  newDesign: false,
  customOnClick: null,
};

const questionList = [
  {
    title: 'Anonymous review of ',
    rating: true,
    buttonTextBox: false,
    question: 'How would you rate working at ',
    displayName: true,
    desc: true,
    back: false,
    error: false,
    buttonDisable: true,
    questionId: '5b5039afa1a4f037c3641c1a',
  },
  {
    title: 'Anonymous review of ',
    rating: false,
    buttonTextBox: true,
    displayName: true,
    question: 'What do you like about working for ',
    desc: false,
    back: true,
    error: false,
    buttonDisable: true,
    questionId: '5b503b1fa1a4f037c3641c1b',
  },
  {
    title: 'Anonymous review of ',
    rating: false,
    buttonTextBox: true,
    question: "What DON'T you like about working there?",
    desc: false,
    back: true,
    error: false,
    buttonDisable: true,
    questionId: '5b503b34a1a4f037c3641c1c',
  },
  {
    title: 'Anonymous review of ',
    rating: false,
    buttonTextBox: true,
    question: "What's your favorite perk / benefit?",
    desc: false,
    back: true,
    error: false,
    buttonDisable: true,
    questionId: '5b503b43a1a4f037c3641c1d',
  },
  {
    reviewBox: true,
  },
];

const initialState = {
  rating: null,
  index: 0,
  responses: [],
  currentCategory: 0,
  categoryRating: []
};

class ReviewBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      newCompanyName: '',
      newCompanyLogo: '',
      questionArrayList: this.cloneArray(questionList),
      currentCategory: 0,
      categoryRating: [],
      submitError: '',
    };
  }

  rate = (rating) => {
    if (this.props.newDesign) {
      let categoryRating = this.state.categoryRating;
      categoryRating[this.state.currentCategory] = rating;

      const categoryId = categories.at(this.state.currentCategory).id;
      this.setState((prevState) => ({
        currentCategory: prevState.currentCategory + 1,
        categoryRating,
        responses: [
          ...prevState.responses,
          { answers: [`${rating + 1}`], questionId: categoryId },
        ],
        index: (this.state.currentCategory === categories.length - 1) ? prevState.index + 1 : prevState.index
      }));
    } else {
      this.setState((prevState) => ({
        rating,
        index: prevState.index + 1,
        responses: [
          ...prevState.responses,
          { answers: [`${rating + 1}`], questionId: '5b5039afa1a4f037c3641c1a' },
        ],
      }));
    }
  };

  cloneArray = (array) => {
    return array.map((val) => ({ ...val }));
  };

  onChangeValue = (text, questionID, item, index) => {
    const questions = this.cloneArray(this.state.questionArrayList);
    questions[index].answer = text;
    questions[index].buttonDisable = text.length < 30;
    this.setState({
      questionArrayList: this.cloneArray(questions),
    });
  };

  onSearch = (option) => {
    if (isEmptyObj(option.valueObj)) {
      return null;
    }
    this.refreshState(option);
  };

  refreshState = (option) => {
    this.setState(
      {
        ...initialState,
        changeCompany: true,
        newCompanyName: option.valueObj.companyName,
        newCompanyId: option.valueObj.companyID,
        questionArrayList: this.cloneArray(questionList),
      }
    );
  };

  onClick = (index, obj) => {
    const { companyID, reviewSource, tracking, newDesign } = this.props;
    const { changeCompany, newCompanyId } = this.state;
    const questions = this.cloneArray(this.state.questionArrayList);

    if (obj.answers[0].length < 30) {
      questions[index].error = true;
      this.setState({
        questionArrayList: this.cloneArray(questions),
      });

      return;
    }

    const urlQueryString = window.location.search;
    questions[index].error = false;

    if (this.state.index === 3) {
      const reviewResponseInput = {
        entityType: 'COMPANY',
        entityValue: changeCompany ? String(newCompanyId) : String(companyID),
        responses: this.state.responses,
        reviewCategory: 'USER_REVIEWS',
        source: 'cpp-on-page-form',
        surveyId: '5b5045f1a1a4f037c3641c20',
        urlQueryString: String(urlQueryString),
      };

      let responseLength = 3;

      if (newDesign) {
        responseLength += categories.length - 1;
      }

      if (this.state.responses.length === responseLength) {
        reviewResponse(reviewResponseInput)
          .then((response) => {
            if (!response?.data?.success) {
              this.setState({
                submitError: response?.data?.errText,
              });

              return;
            }

            this.setState(
              (prevState) => ({
                questionArrayList: this.cloneArray(questions),
                responses: [...prevState.responses, obj],
                index: index + 1,
              })
            );

            tracking.logActivity({}, TRACKING.LOG_ACTIVITY.COMPANY_REVIEW_SUBMITTED);
            gtmLogCompanyReviewSubmitEvent(reviewSource);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    } else {
      this.setState(
        (prevState) => ({
          questionArrayList: this.cloneArray(questions),
          responses: [...prevState.responses, obj],
          index: index + 1,
        })
      );
    }
  };

  getReviewTitle = (companyName) => {
    if (categories.length && categories.length >= this.state.currentCategory)
      if (categories.at(this.state.currentCategory)?.default) {
        return <span>
          {`Share Your Experience`}
        </span>
      }
    return (
      <span>
        {`Rate ${companyName} ${categories.at(this.state.currentCategory).value}`}
      </span>
    )
  }

  onBackClicked = (index) => {
    if (index == 1 && this.props?.newDesign) {
      this.setState({
        index: index - 1,
        currentCategory: 0
      })
    }
    this.setState({ index: index - 1 })
  }

  renderBoxDetailsNewDesign = (item, companyName, companyLogo) => {
    const { index, newCompanyName, newCompanyLogo, changeCompany, categoryRating, currentCategory, submitError } = this.state;
    const reviewCompanyName = changeCompany ? newCompanyName : companyName;
    const reviewCompanyLogo = changeCompany ? newCompanyLogo : companyLogo;

    if (submitError) {
      return (
        <div className='red-text'>
          {submitError}
        </div>
      )
    }

    if (item[index].reviewBox) {
      return (
        <ReviewSubmit
          onSearch={this.onSearch}
          style={{ borderWidth: '0px', marginTop: '0px', padding: '0px' }}
        />
      );
    }

    return (
      <>
        <div className="zp-title-h3 z-mb-24 text-capitalize">{`Work At ${reviewCompanyName}?`}</div>
        {(
          <>
            <div className="d-flex">
              <div>
                <CompanyLogo
                  size="review-card"
                  companyName={reviewCompanyName}
                  companyLogo={reviewCompanyLogo}
                  imgHeight={60}
                  imgWidth={60}
                />
              </div>
              <div className="z-ml-16 d-flex flex-column align-content-start">
                <div className='z-mb-8'>
                  {this.getReviewTitle(reviewCompanyName)}
                </div>
                <div>
                  <Ratings
                    smallStar={true}
                    customClasses={{ star: 'emptyStar', container: 'unsetJustify' }}
                    colorClass={'blue'}
                    ratingIndex={categoryRating[currentCategory]}
                    onRate={this.props.customOnClick ? this.props.customOnClick : this.rate}
                  />
                </div>
              </div>
            </div>
          </>
        )}

      </>
    )
  }

  renderBoxDetails = (item, companyName, rating) => {
    const { index, newCompanyName, changeCompany, submitError } = this.state;
    const reviewCompanyName = changeCompany ? newCompanyName : companyName;

    if (submitError) {
      return (
        <div className='red-text'>
          {submitError}
        </div>
      )
    }

    if (item[index]?.reviewBox) {
      return (
        <ReviewSubmit
          onSearch={this.onSearch}
          style={{ borderWidth: '0px', marginTop: '0px', padding: '0px' }}
        />
      );
    }
    return (
      <>
        {item[index].back && (
          <div
            className={classnames('z-font-600 z-mb-16 d-inline-block z-mt-0', classes.backBtn)}
            onClick={() => {
              this.onBackClicked(index)
            }}
          >
            <i className="fa fa-chevron-left" /> <span>Back</span>
          </div>
        )}


        <div className="zp-title-h3 z-mt-0 z-mb-8">{`${item[index].title} ${reviewCompanyName}`}</div>

        {item[index].desc && (
          <p>{`Do you work at ${reviewCompanyName}? Rate ${reviewCompanyName} as an Employer.`}</p>
        )}

        {!item[index].rating && (
          <div className="form-group z-mb-0">
            <p className={classnames('z-mb-8 z-font-600', classes.middleText)}>
              {item[index].displayName
                ? `${item[index].question} ${reviewCompanyName ? reviewCompanyName : companyName
                }?`
                : `${item[index].question}`}
            </p>
          </div>
        )}

        {item[index].rating &&
          <div className="d-flex flex-row align-items-center" style={{ height: '50px' }}>
            <Ratings
              withRateTip
              customClasses={{ star: 'emptyStar' }}
              ratingIndex={rating}
              onRate={this.rate}
            />
          </div>
        }

        {item[index].buttonTextBox && (
          <>
            <textarea
              type="text"
              className={classnames(
                'form-control z-br-4 z-mb-16',
                classes.formControl
              )}
              spellCheck="false"
              value={item[index].answer || ''}
              onChange={(e) =>
                this.onChangeValue(e.target.value, item[index].questionId, item, index)
              }
            />
            {item[index].error && (
              <div className="text-center z-mb-16">
                <span className="error">Your answer must be at least 30 characters long.</span>
              </div>
            )}
            <ZpButton
              theme="secondary"
              className={classes.nextBtn}
              disabled={item[index].buttonDisable}
              onClick={() =>
                this.onClick(index, {
                  answers: [item[index].answer || ''],
                  questionId: item[index].questionId,
                })
              }
            >
              Next
            </ZpButton>
          </>
        )}
      </>
    );
  };

  render() {
    const { companyName, companyLogo, newDesign } = this.props;
    const { rating, questionArrayList, currentCategory } = this.state;

    if (newDesign && (currentCategory !== categories.length)) {
      return (
        <div className={classnames(classes.container, classes['box-shadow'])}>
          <div
            className={classnames(
              'z-br-4 z-p-20 CPPRightReviewCardContainer',
              classes.card
            )}
          >
            {this.renderBoxDetailsNewDesign(questionArrayList, companyName, companyLogo)}
          </div>
        </div>
      );
    }

    return (
      <div className={classnames(classes.container)}>
        <div
          className={classnames(
            'z-br-4 z-p-20 CPPRightReviewCardContainer',
            classes.card
          )}
        >
          {this.renderBoxDetails(questionArrayList, companyName, rating)}
        </div>
      </div>
    );
  }
}

ReviewBox.propTypes = propTypes;
ReviewBox.defaultProps = defaultProps;

export default withTracking(ReviewBox);